import React, { useState } from "react";
import { 
  Select, 
  Spin, 
  Form, 
  Empty 
} from "common/elements";

export function SearchSelectInput({ fetchOptions, ...props }) {
  const [fetching, setFetching] = useState(false);
  const [options, setOptions] = useState([]);
  let timer = null;
  const debounceFetcher = (value) => {
    if (value) {
      setFetching(true);
      clearTimeout(timer);
      timer = setTimeout(() => {
        fetchOptions(value)
          .then((response) => {
            setOptions(response);
          })
          .finally(() => setFetching(false));
      }, 1000);
    } else {
      onClear();
    }
  };

  const onClear = () => {
    setOptions([]);
    setFetching(false);
  };
  return (
    <Form.Item {...props}>
      <Select
        allowClear={true}
        labelInValue
        filterOption={false}
        defaultValue={props.defaultValue}
        showSearch={true}
        onSelect={props.onSelect}
        onClear={onClear}
        onChange={props.onChange}
        onSearch={debounceFetcher}
        notFoundContent={
          fetching ? (
            <Spin size="small" />
          ) : (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          )
        }
        {...props}
        options={options}
      />
    </Form.Item>
  );
}
